'use client';

import { c as _c } from "react/compiler-runtime";
import { useEngineerIdentity } from '@morfi/backend-sdk-v2/client';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedSwitch } from '@/components/ui/animated-switch';
import { NavLink } from '@/components/ui/navigation-list';
import { useNetworkConfig } from '@/lib/network/use-network-config';
import { logger } from '@/lib/telemetry/logger';
import { useFundingDevtoolsStore } from '@/stores/funding-devtools';
import { useFundingStage } from '../shared/funding-chrome';
import { useFundingLocationOverride } from './use-funding-location-override';
export function FundingDevtoolsPage() {
  const $ = _c(7);
  const t = useTranslations("onramp.devtools");
  let t0;
  if ($[0] !== t) {
    t0 = t("title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h1 className="text-heading-lg">{t0}</h1>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FundingDevtoolsControls />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <main className="mx-auto flex w-full max-w-2xl flex-col gap-6 p-6">{t1}{t2}</main>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export function FundingDevtoolsScreen(t0) {
  const $ = _c(3);
  const {
    onBack
  } = t0;
  const t = useTranslations("onramp.devtools");
  let t1;
  if ($[0] !== t) {
    t1 = t("title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useFundingStage(t1, false, onBack);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-5"><FundingDevtoolsControls /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function FundingDevtoolsControls() {
  const $ = _c(30);
  const t = useTranslations("onramp.devtools");
  const {
    user
  } = useEngineerIdentity();
  const {
    network
  } = useNetworkConfig();
  const enabled = useFundingLocationOverride();
  const setLocationOverride = useFundingDevtoolsStore(_temp);
  let t0;
  if ($[0] !== t) {
    t0 = t("location_override");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h2 id="funding-location-override-label" className="text-heading-sm">{t0}</h2>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = network === "mainnet";
  let t3;
  if ($[4] !== network || $[5] !== setLocationOverride || $[6] !== user) {
    t3 = value => {
      if (!user || network === "mainnet") {
        return;
      }
      setLocationOverride(user.id, value);
      logger.info("onramp.devtools_location_override_changed", {
        enabled: value,
        network
      });
    };
    $[4] = network;
    $[5] = setLocationOverride;
    $[6] = user;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== enabled || $[9] !== t2 || $[10] !== t3) {
    t4 = <AnimatedSwitch aria-labelledby="funding-location-override-label" checked={enabled} disabled={t2} onCheckedChange={t3} />;
    $[8] = enabled;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t4) {
    t5 = <div className="flex items-center justify-between gap-4">{t1}{t4}</div>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== network || $[16] !== t) {
    t6 = network === "mainnet" ? t("sandbox_only") : t("description");
    $[15] = network;
    $[16] = t;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t6) {
    t7 = <p className="text-caption text-foreground-secondary">{t6}</p>;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t5 || $[21] !== t7) {
    t8 = <section className="flex flex-col gap-3 rounded-control bg-background-tertiary p-4">{t5}{t7}</section>;
    $[20] = t5;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t) {
    t9 = t("fixtures");
    $[23] = t;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t9) {
    t10 = <NavLink href="/funding/fixtures" prefetch={false}>{t9}</NavLink>;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t8) {
    t11 = <>{t8}{t10}</>;
    $[27] = t10;
    $[28] = t8;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}
function _temp(state) {
  return state.setLocationOverride;
}